const sortOptions = [
  { name: 'name', label: 'Name' },
  { name: 'unapprovedMessages', label: 'Unapproved Messages' },
];

export default sortOptions;
